module.exports = __webpack_public_path__ + "static/media/noCompany.8cca32ee.svg";